export default {
  install(app, { id }) {
    if (!id) {
      return;
    }

    // Inject the GA script
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(scriptTag);

    // Define gtag
    window.dataLayer = window.dataLayer || [];
    const gtag = (...args) => {
      window.dataLayer.push(args);
    };

    gtag('js', new Date());
    gtag('config', id);

    // Attach to globalProperties
    const { config } = app;
    config.globalProperties.$gtag = gtag;
  },
};
